import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { TinyColor } from '@ctrl/tinycolor';
import { generate } from '@ant-design/colors';
import { generateColors } from '../utils/colors';
var MARK_KEY = 'data-util-key';
/**
 * 获取标记属性
 * @param param0
 * @returns
 */
function getMark() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    mark = _ref.mark;
  if (mark) {
    return mark.startsWith('data-') ? mark : "data-".concat(mark);
  }
  return MARK_KEY;
}
/**
 * 获取 css 容器
 * @param options
 * @returns
 */
function getContainer(options) {
  if (options.attachTo) {
    return options.attachTo;
  }
  return document.querySelector('head') || document.body;
}
/**
 * 查找已存在的节点
 * @param key
 * @param options
 * @returns
 */
function findExistNode(key, options) {
  var container = getContainer(options);
  return Array.from(container.children).find(function (el) {
    return el.tagName === 'STYLE' && el.getAttribute(getMark(options)) === key;
  });
}
/**
 * 注入css
 * @param css css 代码
 * @param key css 唯一key
 * @param options 配置项
 * @returns
 */
export function injectCss(css, key) {
  var _options$csp;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var styleNode = document.createElement('style');
  if ((_options$csp = options.csp) !== null && _options$csp !== void 0 && _options$csp.nonce) {
    var _options$csp2;
    styleNode.nonce = (_options$csp2 = options.csp) === null || _options$csp2 === void 0 ? void 0 : _options$csp2.nonce;
  }
  styleNode.innerHTML = css;
  styleNode.setAttribute(getMark(options), key);
  var container = getContainer(options);
  var firstChild = container.firstChild;
  if (options.prepend && container.prepend) {
    container.prepend(styleNode);
  } else if (options.prepend && firstChild) {
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }
  return styleNode;
}
/**
 * 更新css
 * @param css css代码
 * @param key 唯一key
 * @param options 配置项
 * @returns
 */
export function updateCss(css, key) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var existNode = findExistNode(key, options);
  if (existNode) {
    var _options$csp3, _options$csp4;
    if ((_options$csp3 = options.csp) !== null && _options$csp3 !== void 0 && _options$csp3.nonce && existNode.nonce !== ((_options$csp4 = options.csp) === null || _options$csp4 === void 0 ? void 0 : _options$csp4.nonce)) {
      var _options$csp5;
      existNode.nonce = (_options$csp5 = options.csp) === null || _options$csp5 === void 0 ? void 0 : _options$csp5.nonce;
    }
    if (existNode.innerHTML !== css) {
      existNode.innerHTML = css;
    }
    return existNode;
  }
  return injectCss(css, key, options);
}
var mark = "-".concat(Date.now(), "-").concat(Math.random());
/**
 *
 * @param theme
 * @param target
 */
export function registerTheme(theme) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ':root';
  registerAntTheme('ant', {
    primaryColor: theme['color-primary-6'],
    warningColor: theme['color-warning-6'],
    errorColor: theme['color-error-6'],
    processingColor: theme['color-primary-6']
  }, null, selector);
  var cssList = Object.entries(theme).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      k = _ref3[0],
      v = _ref3[1];
    return "--".concat(k, ": ").concat(v, ";");
  });
  updateCss("\n".concat(selector, " {\n  ").concat(cssList.join('\n  '), "\n}\n"), "-stepin-".concat(mark, "-").concat(selector, "-dynamic-theme"), {
    prepend: false
  });
}
/**
 * 注册 antd 主题
 * @param globalPrefixCls
 * @param theme
 * @param selector
 */
export function registerAntTheme(globalPrefixCls, theme, background) {
  var selector = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ':root';
  var variables = {};
  var formatColor = function formatColor(color, updater) {
    var clone = color.clone();
    clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
    return clone.toRgbString();
  };
  var fillColor = function fillColor(colorVal, type) {
    var baseColor = new TinyColor(colorVal);
    var colorPalettes = generateColors(baseColor.toRgbString(), background);
    variables["".concat(type, "-color")] = formatColor(baseColor);
    variables["".concat(type, "-color-disabled")] = colorPalettes[1];
    variables["".concat(type, "-color-hover")] = colorPalettes[4];
    variables["".concat(type, "-color-active")] = colorPalettes[6];
    variables["".concat(type, "-color-outline")] = baseColor.clone().setAlpha(0.2).toRgbString();
    variables["".concat(type, "-color-deprecated-bg")] = colorPalettes[1];
    variables["".concat(type, "-color-deprecated-border")] = colorPalettes[3];
  };
  // ================ Primary Color ================
  if (theme.primaryColor) {
    fillColor(theme.primaryColor, 'primary');
    var primaryColor = new TinyColor(theme.primaryColor);
    var primaryColors = generateColors(primaryColor.toRgbString(), background);
    // Legacy - We should use semantic naming standard
    primaryColors.forEach(function (color, index) {
      variables["primary-".concat(index + 1)] = color;
    });
    variables['primary-color-deprecated-l-35'] = formatColor(primaryColor, function (c) {
      return c.lighten(35);
    });
    variables['primary-color-deprecated-l-20'] = formatColor(primaryColor, function (c) {
      return c.lighten(20);
    });
    variables['primary-color-deprecated-t-20'] = formatColor(primaryColor, function (c) {
      return c.tint(20);
    });
    variables['primary-color-deprecated-t-50'] = formatColor(primaryColor, function (c) {
      return c.tint(50);
    });
    variables['primary-color-deprecated-f-12'] = formatColor(primaryColor, function (c) {
      return c.setAlpha(c.getAlpha() * 0.12);
    });
    var primaryActiveColor = new TinyColor(primaryColors[0]);
    variables['primary-color-active-deprecated-f-30'] = formatColor(primaryActiveColor, function (c) {
      return c.setAlpha(c.getAlpha() * 0.3);
    });
    variables['primary-color-active-deprecated-d-02'] = formatColor(primaryActiveColor, function (c) {
      return c.darken(2);
    });
  }
  // ================ Success Color ================
  if (theme.successColor) {
    fillColor(theme.successColor, 'success');
  }
  // ================ Warning Color ================
  if (theme.warningColor) {
    fillColor(theme.warningColor, 'warning');
  }
  // ================= Error Color =================
  if (theme.errorColor) {
    fillColor(theme.errorColor, 'error');
  }
  // ================= Info Color ==================
  if (theme.infoColor) {
    fillColor(theme.infoColor, 'info');
  }
  // Convert to css variables
  var cssList = Object.keys(variables).reduce(function (p, key) {
    p["--".concat(globalPrefixCls, "-").concat(key)] = variables[key];
    return p;
  }, {});
  updateCssPartially(cssList, "-ant-".concat(mark, "-:").concat(selector, "-dynamic-theme"), selector);
}
/**
 * 注册 SeriesColor
 * @param type
 * @param colors
 */
export function registerSeriesColor(type, colors) {
  var seriesColor = Object.keys(colors).reduce(function (p, key) {
    return (p["--color-".concat(type, "-").concat(key)] = colors[key]) && p;
  }, {});
  updateCssPartially(seriesColor, "-stepin-".concat(mark, "-:root-dynamic-theme"), ':root', {
    prepend: true
  });
  registerAntColors(type, colors);
}
/**
 * 注册主题色
 * @param colors
 * @deprecated since version 1.0.2 use theme/storage to config theme instead
 */
export function registerThemeColor(colors) {
  var keys = Object.keys(colors);
  var antColors = keys.reduce(function (p, c) {
    p[c + 'Color'] = colors[c];
    return p;
  }, {});
  registerAntTheme('ant', antColors);
  var allColors = keys.map(function (type) {
    var palette = generate(colors[type]);
    var variables = palette.reduce(function (p, c, index) {
      return (p["--color-".concat(type, "-").concat(index + 1)] = c) && p;
    }, {});
    variables["--color-".concat(type)] = palette[5];
    variables["--color-".concat(type, "-bg")] = palette[0];
    variables["--color-".concat(type, "-bg-hover")] = palette[1];
    variables["--color-".concat(type, "-border")] = palette[2];
    variables["--color-".concat(type, "-border-hover")] = palette[3];
    variables["--color-".concat(type, "-hover")] = palette[4];
    variables["--color-".concat(type, "-active")] = palette[6];
    variables["--color-".concat(type, "-text")] = palette[5];
    variables["--color-".concat(type, "-text-hover")] = palette[4];
    variables["--color-".concat(type, "-text-active")] = palette[6];
    return variables;
  }).reduce(function (p, c) {
    p = _objectSpread(_objectSpread({}, p), c);
    return p;
  }, {});
  updateCssPartially(allColors, "-stepin-".concat(mark, "-:root-dynamic-theme"), ':root', {
    prepend: true
  });
}
/**
 * 注册中性色
 * @param colors
 */
export function registerMiddleColors(colors, selector) {
  var variables = Object.entries(colors).filter(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      _ = _ref5[0],
      v = _ref5[1];
    return v !== undefined;
  }).reduce(function (p, _ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      k = _ref7[0],
      v = _ref7[1];
    return (p["--color-".concat(k)] = v) && p;
  }, {});
  updateCssPartially(variables, "-stepin-".concat(mark, "-:").concat(selector, "-dynamic-theme"), selector);
}
/**
 * 增量更新 css
 * @param cssList
 * @param key
 * @param selector
 * @param options
 */
function updateCssPartially(cssList, key, selector) {
  var _loadHtmlCss;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var existCss = (_loadHtmlCss = loadHtmlCss(key, options)) !== null && _loadHtmlCss !== void 0 ? _loadHtmlCss : {};
  var unionCss = _objectSpread(_objectSpread({}, existCss), cssList);
  var cssContent = Object.entries(unionCss).map(function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
      k = _ref9[0],
      v = _ref9[1];
    return "".concat(k, ": ").concat(v, ";");
  }).join('\r\n  ');
  updateCss("\n".concat(selector, " {\n  ").concat(cssContent, "\n}\n"), key, options);
}
/**
 * 注册 ant 系列颜色
 * @param type
 * @param colors
 */
function registerAntColors(type, colors) {
  var selector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ':root';
  var antColors = {
    'deprecated-bg': colors.bg,
    active: colors.active,
    'deprecated-border': colors.border,
    hover: colors.hover
  };
  var variables = Object.entries(antColors).filter(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
      _ = _ref11[0],
      v = _ref11[1];
    return v !== undefined;
  }).reduce(function (p, _ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
      k = _ref13[0],
      v = _ref13[1];
    return (p["--ant-".concat(type, "-color-").concat(k)] = v) && p;
  }, {});
  updateCssPartially(variables, "-ant-".concat(mark, "-dynamic-theme"), selector, {
    prepend: false
  });
}
/**
 * 加载 html中的 css
 * @param key
 * @param options
 */
function loadHtmlCss(key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var node = findExistNode(key, options);
  if (node) {
    var cssContent = node.innerHTML.match(/(?<=\{)(.|\s)*(?=\})/g)[0];
    var css = cssContent.replace(/\/\*((?!\*\/).|\s)*\*\//g, '').split(/\r?\n/).join('').replace(/(\s)*/g, '').split(';').filter(function (item) {
      return !/^(\s){0,}$/.test(item);
    }).reduce(function (p, c) {
      var _c$split = c.split(':'),
        _c$split2 = _slicedToArray(_c$split, 2),
        k = _c$split2[0],
        v = _c$split2[1];
      p[k] = v;
      return p;
    }, {});
    return css;
  }
}
/**
 * 注册色盘
 * @param type 色盘类型
 * @param color 色盘主色
 */
export function registerColorPalettes(type, color, selector, background) {
  var palette = generateColors(color, background);
  palette[5] = color;
  var variables = palette.reduce(function (p, c, index) {
    return (p["--color-".concat(type, "-").concat(index + 1)] = c) && p;
  }, {});
  variables["--color-".concat(type)] = color;
  updateCssPartially(variables, "-stepin-".concat(mark, "-:").concat(selector, "-dynamic-theme"), selector);
}
/**
 * 注册功能色
 * @param type
 * @param colors
 */
export function registerFunctionalColor(type, colors, selector, background) {
  var variables = Object.entries(colors).filter(function (_ref14) {
    var _ref15 = _slicedToArray(_ref14, 2),
      k = _ref15[0],
      v = _ref15[1];
    return v !== undefined && k !== 'DEFAULT';
  }).reduce(function (p, _ref16) {
    var _ref17 = _slicedToArray(_ref16, 2),
      k = _ref17[0],
      v = _ref17[1];
    return (p["--color-".concat(type, "-").concat(k)] = v) && p;
  }, {});
  if (colors.DEFAULT) {
    registerAntTheme('ant', _defineProperty({}, type + 'Color', colors.DEFAULT), background, selector);
    registerColorPalettes(type, colors.DEFAULT, selector, background);
  }
  registerAntColors(type, colors, selector);
  updateCssPartially(variables, "-stepin-".concat(mark, "-:").concat(selector, "-dynamic-theme"), selector);
}
/**
 * 注册系统主色
 * @param colors
 */
export function registerPrimaryColor(colors, selector, background) {
  registerFunctionalColor('primary', colors, selector, background);
}
/**
 * 注册 css 变量
 * @param objectVars -
 * - input cssVar object: -
 * {
 *    color: red;
 *    size-base: 12px;
 * }
 * - will register in css like this:
 * html {
 *    --color: red;
 *    --size-base: 12px;
 * }
 */
export function registerCssVariables(objectVars, selector) {
  var variables = Object.entries(objectVars).filter(function (_ref18) {
    var _ref19 = _slicedToArray(_ref18, 2),
      k = _ref19[0],
      v = _ref19[1];
    return v !== undefined && v !== null;
  }).reduce(function (p, _ref20) {
    var _ref21 = _slicedToArray(_ref20, 2),
      k = _ref21[0],
      v = _ref21[1];
    return (p["--".concat(k)] = v) && p;
  }, {});
  updateCssPartially(variables, "-stepin-".concat(mark, "-:").concat(selector, "-dynamic-theme"), selector);
}
/**
 * 卸载 css 变量
 * @param selector
 */
export function umountCssVariables(selector) {
  updateCss("\n".concat(selector, " {\n}\n"), "-stepin-".concat(mark, "-:").concat(selector, "-dynamic-theme"));
}